<template>
    <v-autocomplete
            label="Pais"
            :items="paises"
            :value="value"
            :multiple="multiple"
            hide-details
            :chips="chips"
            item-value="id"
            item-text="nombre"
            @input="actualizaValor($event)"
            hide-selected
            small-chips
    >
        <template slot="selection" slot-scope="data">
            <v-chip small
                    :close="multiple"
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi"
                    :key="JSON.stringify(data.item)"
            >
                <v-avatar>
                    <img :src="'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/'+ data.item.alfa2.toLowerCase() +'.svg'"/>
                </v-avatar>
                {{ data.item.nombre }}
            </v-chip>
        </template>
        <template slot="item" slot-scope="data">
            <template>
                <v-list-tile-avatar>
                    <img :src="'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/'+ data.item.alfa2.toLowerCase() +'.svg'"/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.nombre"></v-list-tile-title>
                </v-list-tile-content>
            </template>
        </template>
    </v-autocomplete>
</template>
<script>
    export default {
        name: 'pais-select',
        props: ['multiple', 'value','chips'],
        data() {
            return {
                paises: []
            }
        },
        mounted(){
            this.$http.post('pais/select')
                .then(r => {
                    this.paises = r.data;
                })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PaisSelect.vue